// extracted by mini-css-extract-plugin
export default {"icon":"add_icon___icon___e3817fc3","background":"add_icon___background___c8a51b4a"};